import { render, staticRenderFns } from "./BranchOfficeEdit.vue?vue&type=template&id=70dc7dae&scoped=true"
import script from "./BranchOfficeEdit.vue?vue&type=script&lang=js"
export * from "./BranchOfficeEdit.vue?vue&type=script&lang=js"
import style0 from "./BranchOfficeEdit.vue?vue&type=style&index=0&id=70dc7dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc7dae",
  null
  
)

export default component.exports